import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer from '../reducers';
import { analytics } from './analyticsMiddleware';

const configureStore = () => {
  const sagaMiddleware = createSagaMiddleware();
  // eslint-disable-next-line
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const middleware = [sagaMiddleware, analytics];

  const middlewares =
    process.env.NODE_ENV === 'production'
      ? applyMiddleware(...middleware)
      : composeEnhancers(applyMiddleware(...middleware));

  return {
    ...createStore(rootReducer, middlewares),
    runSaga: sagaMiddleware.run
  };
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.js